import React, { createContext, useContext, useEffect, useState } from "react";
import ProductsService from "../api/services/products.service";
import { CurrencyTypes } from "../api/types/products.types";

interface CurrenciesContextType {
  currencies: CurrencyTypes[];
  currencyId: number | null;
  setCurrencyId: (id: number) => void;
  currency: string;
  setCurrency: (value: string) => void;
}

const CurrenciesContext = createContext<CurrenciesContextType>({
  currencies: [],
  currencyId: null,
  setCurrencyId: () => {},
  currency: "",
  setCurrency: () => {},
});

export const CurrenciesProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [currencies, setCurrencies] = useState<CurrencyTypes[]>([]);
  const [currency, setCurrencyState] = useState("");
  const [currencyId, setCurrencyIdState] = useState<number | null>(null);

  useEffect(() => {
    if (currency && currencyId !== null) {
      localStorage.setItem("admin_currency", currency);
      localStorage.setItem("admin_currencyId", String(currencyId));
    }
  }, [currency, currencyId]);

  useEffect(() => {
    const getData = async () => {
      try {
        const res = await ProductsService.getCurrency();
        setCurrencies(res.data);
        if (res.data.length > 0) {
          const savedCurrency = localStorage.getItem("admin_currency");
          const savedCurrencyId = localStorage.getItem("admin_currencyId");

          if (savedCurrency && savedCurrencyId) {
            const savedCurrencyInApi = res.data.find(
              (curr: CurrencyTypes) =>
                curr.name === savedCurrency &&
                curr.id === Number(savedCurrencyId),
            );
            if (savedCurrencyInApi) {
              setCurrencyState(savedCurrency);
              setCurrencyIdState(Number(savedCurrencyId));
              return;
            }
          }

          // Default to first currency if no saved preference
          const firstCurrency = res.data[0];
          setCurrencyState(firstCurrency.name);
          setCurrencyIdState(firstCurrency.id);
        }
      } catch (error) {
        console.error("Error fetching currencies:", error);
      }
    };

    getData();
  }, []);

  const setCurrency = (value: string) => {
    setCurrencyState(value);
  };

  const setCurrencyId = (id: number) => {
    setCurrencyIdState(id);
  };

  return (
    <CurrenciesContext.Provider
      value={{
        currencies,
        currency,
        setCurrency,
        currencyId,
        setCurrencyId,
      }}
    >
      {children}
    </CurrenciesContext.Provider>
  );
};

export const useCurrencies = () => useContext(CurrenciesContext);
